import './App.css';
import SendGiftCard from './containers/SendGiftCard';
import {
  BrowserRouter,
  Switch,
  Route,
  Redirect
} from 'react-router-dom';


function App() {
  return (
    <div className='App'>
      <BrowserRouter>
        <Switch>
          <Route path="/send_gift_card">
            <SendGiftCard />
          </Route>
          <Route path="/">
            <Redirect to="/send_gift_card" />
          </Route>
        </Switch>
      </BrowserRouter>
    </div>
  );
}

export default App;
